import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { InfoBox } from "ui/info-box";
import { MinuteRender } from "ui/minute-render";
import {
  calculateTimeDiff,
  formatDateFromDifference,
  timeDifferenceWithTimezone,
} from "util/time";

function InnerDeviceLocalTimeBox(props) {
  const { color, timeDiff, timezone } = props;

  const parsedTime = formatDateFromDifference(timeDiff);
  const subText = `TZ (${timezone}) | ${calculateTimeDiff(timeDiff)}`;

  return (
    <InfoBox
      title="Time"
      icon="clock-o"
      desc={parsedTime}
      subText={subText}
      color={color}
    />
  );
}

InnerDeviceLocalTimeBox.propTypes = {
  color: PropTypes.string.isRequired,
  timeDiff: PropTypes.object,
  timezone: PropTypes.string,
};

function DeviceLocalTimeBox(props) {
  const { color, device, stats } = props;
  const time = get(stats, "player.localTime", null);
  const timezone = get(device, "timezone", null);

  const timeDiff = timeDifferenceWithTimezone(time, timezone);

  return (
    <MinuteRender>
      <InnerDeviceLocalTimeBox
        color={color}
        timeDiff={timeDiff}
        timezone={timezone}
      />
    </MinuteRender>
  );
}

DeviceLocalTimeBox.propTypes = {
  color: PropTypes.string.isRequired,
  device: PropTypes.object.isRequired,
  stats: PropTypes.object.isRequired,
};

export { DeviceLocalTimeBox };
